/** @jsxImportSource @emotion/react */

import React, { useState } from 'react';
import styled from 'styled-components';
import * as size from '@constant/size';
import * as color from '@constant/color';
import TextBlock from '@component/common/block/text-block';
import IconBlock from '@component/common/block/icon-block';
import Scroll from '@component/common/scroll';

interface IProps {
  question: string;
  answer: string;
  initialOpen?: boolean;
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  gap: 5px;
  //gap: ${size.MARGIN_1};
`;

const TERM_SCROLL_HEIGHT = '100px';

const QUESTION_TEXT_DESIGN = {
  text: { size: 'medium', color: color.BLACK_2, bold: false },
  box: { alignX: 'left', padding: `0 0 0px 0` },
} as const;

const ANSWER_TEXT_DESIGN = {
  text: { size: 'medium', color: color.GRAY_1 },
  box: { alignX: 'left', maxWidth: '500' },
} as const;

const QuestionContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
`;

const AnswerContainer = styled.div`
  white-space: pre-wrap;
  padding: ${size.MARGIN_1};
  border-radius: ${size.BORDER_RADIUS_2};
  background-color: ${color.GRAY_4};
  width: 100%;
  max-width: 500px;
`;

const QuestionAndAnswer: React.FC<IProps> = ({ question, answer, initialOpen = false }) => {
  const [isClickedA, setIsClickedA] = useState<boolean>(initialOpen);
  const handleClickA = () => setIsClickedA(!isClickedA);

  return (
    <Wrapper>
      <QuestionContainer>
        <IconBlock
          icon={isClickedA ? 'up' : 'down'}
          design={{ icon: { size: 'medium', kind: 'outlined' }, box: { event: { cursor: 'pointer' } } }}
          click={{ handler: handleClickA }}
        />
        <TextBlock text={question} design={QUESTION_TEXT_DESIGN} />
      </QuestionContainer>
      {isClickedA && (
        <AnswerContainer>
          {/*<Scroll direction='y' height={TERM_SCROLL_HEIGHT}>*/}
          <TextBlock text={answer} design={ANSWER_TEXT_DESIGN} />
          {/*</Scroll>*/}
        </AnswerContainer>
      )}
    </Wrapper>
  );
};

export default QuestionAndAnswer;
